// Generated by frontend/scripts/release-stamp.js. Do not edit by hand.
export const RELEASE_INFO = Object.freeze({
  "appStamp": "DOS 26-1755/B43F7",
  "appFingerprint": "B43F71559D5B1F5B42E1A422C57617A0684DF1F9169E0858469FB7A358882E50",
  "expectedMigration": "20260808000426",
  "sourceFileCount": 1755
});

export default RELEASE_INFO;
